<template lang="pug">
  v-nav-tabs(
    :options="options"
    @tab-click="handleTabClick")
</template>

<script>
import navigationMixin from '@/mixins/navigation.mixin.js'

export default {
  name: 'PlanningTabs',

  mixins: [navigationMixin],

  computed: {
    items () {
      return [
        { id: 0, title: 'base.schedule', path: `planning` },
        { id: 1, title: 'base.leftovers', path: `planning/leftovers` }
      ]
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.id === 0) {
        this.$store.dispatch('planning/planningLoadData')
      }
    }
  }
}
</script>
